import React, { useEffect } from 'react'
import { makeStyles, Container, Grid, Button } from '@material-ui/core';
import {
  Search,
  BackNavAdmin,
  DialogAllUserFunctions,
  UserCards
} from '../../components';
import { useWindowSize } from '../../hooks';
import config from '../../config';
import { useSelector, useDispatch } from "react-redux";
import { UsersFilter } from './../../components/ManageUsers/UsersFilter';
import { manageUsersActions, userFunctionActions } from './../../actions'
import { UsersTable } from './../../components/Tables/UsersTable'
import AddCircle from '@material-ui/icons/AddCircle';
import { history } from '../../helpers';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  filters: {
    width: '100%',
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    float: "right"
  }
}));

export const UsersPage = () => {
  const classes = useStyles();
  const [width] = useWindowSize();
  const dispatch = useDispatch();
  const { paging } = useSelector((state) => state.manageUsers);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(manageUsersActions.getUsers(
      paging.search,
      1,
      paging.sort,
      paging.limit,
    ));
    dispatch(userFunctionActions.clearAdminUserEdit())
    dispatch(userFunctionActions.clearState())
  }, [])

  function sendQuery(query) {
    dispatch(manageUsersActions.getFilteredUsers(
      query,
      1,
      paging.sort,
      paging.limit,
      paging.statusCode
    ));
  }

  return (
    <>
      <DialogAllUserFunctions />
      <BackNavAdmin title={t('usuarios')} />
      <Container maxWidth="lg" className={classes.root}>
        <div className={classes.filters}>
          <UsersFilter />
          <Search 
            placeholder={t('pesquisar')} 
            value={paging.search} 
            query={sendQuery}
          />
        </div>
        <Grid container>
          <Grid item xs={12}>
            {width > config.RESPONSIVE_MOBILE ? <UsersTable /> : <UserCards />}
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
